if (!customElements.get('related-products')) {
  customElements.define(
    'related-products',
    class Related extends HTMLElement {
      connectedCallback() {
        this.loadRelatedProducts();
        this.loadRecentlyViewedProducts();
      }

      loadRelatedProducts() {
        this.relatedProducts = this.querySelector('[data-related-products]');

        if (!this.relatedProducts) {
          return;
        }

        const sectionId = this.getAttribute('data-section-id');
        const productId = this.getAttribute('data-product-id');
        const limit = this.getAttribute('data-limit');
        const requestUrl = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

        fetch(requestUrl)
          .then((response) => {
            if (!response.ok) {
              const error = new Error(response.status);
              this.hideRelated();
              throw error;
            }
            return response.text();
          })
          .then((data) => {
            const createdElement = document.createElement('div');
            createdElement.innerHTML = data;
            const inner = createdElement.querySelector('[data-related-products]');

            if (!inner) return;

            if (inner.querySelector('[data-product-block]')) {
              this.relatedProducts.innerHTML = inner.innerHTML;
            }
          });
      }

      loadRecentlyViewedProducts() {
        this.recentlyViewed = this.querySelector('recently-viewed');

        if (!this.recentlyViewed) return;

        this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', () => {
          this.handleRecentlyViewedResponse();
        });
      }

      handleRecentlyViewedResponse() {
        const recentlyViewedWrapper = this.recentlyViewed.closest('[data-recently-viewed-wrapper]');
        const recentProducts = this.recentlyViewed.querySelectorAll('[data-product-block]');
        const aosItem = this.recentlyViewed.querySelectorAll('[data-aos]');
        const columnsContainer = this.recentlyViewed.querySelector('[data-columns]');
        const slider = this.recentlyViewed.querySelector('grid-slider');
        const minimumNumberProducts = parseInt(this.recentlyViewed.getAttribute('data-minimum')) || 1;
        const checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
        const checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;
        const columnsMobile = parseInt(columnsContainer?.getAttribute('data-column-mobile'));
        const columnsDesktop = parseInt(columnsContainer?.getAttribute('data-columns'));

        if (checkRecentInRelated || checkRecentOutsideRelated) {
          if (checkRecentOutsideRelated) {
            this.classList.remove('hidden');
          }

          if (slider) {
            requestAnimationFrame(() => {
              slider.dispatchEvent(new CustomEvent('theme:slider:resize', {bubbles: true}));
            });
          }

          if (columnsContainer) {
            const desktopClassMap = {
              1: 'one-whole',
              2: 'one-half',
              3: 'one-third',
              4: 'one-quarter',
            };

            columnsContainer.querySelectorAll('[data-slide]').forEach((slide) => {
              // Mobile classes
              slide.classList.toggle('mobile--one-half', columnsMobile === 2);
              slide.classList.toggle('mobile--one-whole', columnsMobile !== 2);

              // Desktop classes
              slide.classList.remove('one-whole', 'one-half', 'one-third', 'one-quarter');
              slide.classList.add(desktopClassMap[columnsDesktop]);
            });
          }

          let itemsSet = [];
          this.recentlyViewed.addEventListener('theme:target:animate', (event) => {
            itemsSet.push(event.detail);
            if (itemsSet.length === aosItem.length) {
              requestAnimationFrame(() => aosItem.forEach((item) => item.classList.add('aos-animate')));
            }
          });
        }
      }

      hideRelated() {
        const tab = this.relatedProducts.closest('[data-tab]');
        const tabsHolder = this.relatedProducts.closest('[data-tabs-holder]');
        const tabsLink = tabsHolder?.querySelector(`[data-tabs-link="${tab.dataset.tab}"]`);

        tab?.remove();

        if (!tabsLink) return;
        tabsLink.remove();
        tabsHolder.querySelector('[data-tabs-link]')?.dispatchEvent(new Event('click'));
      }
    }
  );
}
